import clsx from 'clsx';
import React from 'react';

import { TextButton } from '../Button/variants';

const CookiesSettingsBtn = () => {
  return (
    <div>
      <TextButton
        id="ot-sdk-btn"
        className={clsx(
          'ot-sdk-show-settings !mt-8 !w-auto cursor-pointer !justify-start !border-none !bg-transparent !p-0 !font-suisse-screen text-overline-md !text-grayscale-beige !no-underline !opacity-50 !transition-colors hover:!text-primary-magenta hover:!opacity-100 focus:!text-primary-magenta'
        )}
        as="link"
      >
        Cookies Settings
      </TextButton>
    </div>
  );
};

export default CookiesSettingsBtn;
